import React from 'react';
import {Link, useLocation} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPerson,faPeopleGroup,faBoxOpen,faArrowRightToCity,faRocket,faMountainSun,faHotel,faHouse,faUtensils,faBuildingFlag,faCalendarCheck,faRightFromBracket} from '@fortawesome/free-solid-svg-icons';

const handleLogout = () => {
    localStorage.removeItem('adminToken');
    window.location.href = '/login';
};

const Menu = () => {
    const location = useLocation();
    return (
        <div className='menu'>
            <div className="logo">
                <h1>AYRARAT</h1>
            </div>
            <Link to={'/private-tours'} className={`mt-3 ${location.pathname === '/private-tours' && 'active-link'}`}>
                <FontAwesomeIcon icon={faPerson}/>
                <span>Private Tours</span>
            </Link>
            <Link to={'/group-tours'} className={`mt-3 ${location.pathname === '/group-tours' && 'active-link'}`}>
                <FontAwesomeIcon icon={faPeopleGroup}/>
                <span>Group Tours</span>
            </Link>
            <Link to={'/tour-packages'} className={`mt-3 ${location.pathname === '/tour-packages' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBoxOpen}/>
                <span>Packages</span>
            </Link>
            <Link to={'/abroad'} className={`mt-3 ${location.pathname === '/abroad' && 'active-link'}`}>
                <FontAwesomeIcon icon={faArrowRightToCity}/>
                <span>Lesser Armenia</span>
            </Link>
            <Link to={'/other-tours'} className={`mt-3 ${location.pathname === '/other-tours' && 'active-link'}`}>
                <FontAwesomeIcon icon={faRocket}/>
                <span>Europe Tours</span>
            </Link>
            <Link to={'/armenia'} className={`mt-3 ${location.pathname === '/armenia' && 'active-link'}`}>
                <FontAwesomeIcon icon={faMountainSun}/>
                <span>About Armenia</span>
            </Link>
            <Link to={'/hotel'} className={`mt-3 ${location.pathname === '/hotel' && 'active-link'}`}>
                <FontAwesomeIcon icon={faHotel}/>
                <span>Hotels</span>
            </Link>
            <Link to={'/apartment'} className={`mt-3 ${location.pathname === '/apartment' && 'active-link'}`}>
                <FontAwesomeIcon icon={faHouse}/>
                <span>Apartments</span>
            </Link>
            <Link to={'/restaurant'} className={`mt-3 ${location.pathname === '/restaurant' && 'active-link'}`}>
                <FontAwesomeIcon icon={faUtensils}/>
                <span>Restaurants</span>
            </Link>
            <Link to={'/embassy'} className={`mt-3 ${location.pathname === '/embassy' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBuildingFlag}/>
                <span>Embassies</span>
            </Link>
            <Link to={'/news'} className={`mt-3 ${location.pathname === '/news' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBuildingFlag}/>
                <span>News</span>
            </Link>
            <Link to={'/guide'} className={`mt-3 ${location.pathname === '/guide' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBuildingFlag}/>
                <span>GuideBook</span>
            </Link>
            <Link to={'/region'} className={`mt-3 ${location.pathname === '/region' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBuildingFlag}/>
                <span>Region</span>
            </Link>
            <Link to={'/seo'} className={`mt-3 ${location.pathname === '/seo' && 'active-link'}`}>
                <FontAwesomeIcon icon={faBuildingFlag}/>
                <span>Seo</span>
            </Link>
            <Link to={'/bookings'} className={`mt-3 ${location.pathname === '/bookings' && 'active-link'}`}>
                <FontAwesomeIcon icon={faCalendarCheck}/>
                <span>Bookings</span>
            </Link>
            <button
                onClick={handleLogout}
                className='mt-3'
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    width: '100%',
                    padding: '8px 16px',
                    color: '#e05252',
                    fontWeight: 500
                }}
            >
                <FontAwesomeIcon icon={faRightFromBracket}/>
                <span>Logout</span>
            </button>
        </div>
    );
};

export default Menu;
